/** Reports 画面・使用簿 PDF 在庫一覧で共通の view キー（backend と同一） */
export const USAGE_LEDGER_INVENTORY_VIEW = 'usage_ledger_inventory';

/** 使用簿 PDF 在庫一覧の既定集計軸（Reports 表は列の表示/非表示に連動。PDF はこの固定軸） */
export const USAGE_LEDGER_INVENTORY_HIERARCHY = [
  'creator',
  'storage_room',
  'drawer',
  'case',
  'bsl_level',
  'pathogen_genus',
  'pathogen_species',
  'pathogen_subspecies',
  'pathogen_strain',
  'type',
] as const;
